// extracted by mini-css-extract-plugin
module.exports = {"stores":"StoresDesktop_stores__2AhGB","brands":"StoresDesktop_brands__euoLE","title":"StoresDesktop_title__3qZZi"};